import { render, staticRenderFns } from "./payment-info.component.vue?vue&type=template&id=e4f72156&scoped=true"
import script from "./payment-info.component.vue?vue&type=script&lang=js"
export * from "./payment-info.component.vue?vue&type=script&lang=js"
import style0 from "./payment-info.component.vue?vue&type=style&index=0&id=e4f72156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f72156",
  null
  
)

export default component.exports